<template>
  <section class="dashboard-container flex flex-wrap flex-col">
    <SmartRow>
      <SmartTitle
        class="form-list__title lg:col-12 mb-2 mt-2"
        weight="medium"
        heading="1">
        Relatório Analítico
      </SmartTitle>
    </SmartRow>
    <SmartRow>
      <SmartButtonDash
        v-for="(report, index) in analyticalReports"
        :key="index"
        v-bind="report"
        class="lg:col-4 text-left my-2 flex flex-wrap"
      />
    </SmartRow>
  </section>
</template>

<script>
// @flow
export default {
  data() {
    return {
      analyticalReports: [
        {
          title: 'Carteira de PDV TIM',
          description: 'Identifique o total de PDVS e seus responsáveis.',
          buttonText: 'Exportar',
          action: () => {
            this.pushToDownload('chip');
          }
        },
        {
          title: 'Usuários TIM Smart',
          description: 'Saiba quem são os usuários ativos e inativos do Smart',
          buttonText: 'Exportar',
          action: () => {
            this.pushToDownload('usuario');
          }
        },
        {
          title: 'Carteira PDV (On-Demand)',
          description: 'Saiba quais são os PDVS criados pela funcionalidade de "usar minha localização”',
          buttonText: 'Exportar',
          action: () => {
            this.pushToDownload('carteira');
          }
        },
        {
          title: 'Jornada com KM',
          description: 'Tudo sobre as jornadas, desde quantos KMs ao número de visitas realizada na mesma.',
          buttonText: 'Exportar',
          action: () => {
            this.pushToDownload('jornada');
          }
        },
        {
          title: 'Usabilidade',
          description: 'Saiba todas as ações dos usuários do sistema.',
          buttonText: 'Exportar',
          action: () => {
            this.pushToDownload('usabilidade');
          }
        }
      ]
    };
  },
  methods: {
    pushToDownload(report: string) {
      this.$router.push({
        name: 'DownloadReport',
        params: { report }
      });
    }
  }
};
</script>
